import { useCallback, useState, useEffect } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import { Button, List, ListItem, ListItemButton } from "@mui/material";
import { uploadFileThunk } from "../../../../../components/general/generalThunk";
import { useDispatch } from "react-redux";
import SnackbarMessage from "../../../../../components/snackBar/snackBar";

function CustomNode({ id, isConnectable, data }) {
  const { setNodes } = useReactFlow();
  const dispatch = useDispatch();
  const [url, setUrl] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [showHeader, setShowHeader] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);
  const [state, setState] = useState({
    label: "Target node",
    listButton: "",
    header: "",
    footer: "",
    url: url,
    message: "",
    buttons: [],
    list: [],
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    setState(data && data.state);
    if (data && data.state && data.state.list && data.state.list.length === 0) {
      setUrl(data && data.state.url ? data.state.url : url);
    }
  }, [data]);

  const { deleteElements } = useReactFlow();

  const handleDeleteNode = useCallback(() => {
    deleteElements({ nodes: [{ id }] });
  }, [id, deleteElements]);

  const [isHover, setIsHover] = useState(false);

  const handleNodeFocus = () => {
    setState((prevState) => ({
      ...prevState,
      isNodeClicked: true,
    }));
  };

  const handleChange = async (e, index) => {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "url") {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const fileSize = selectedFile.size;

        const fileSizeInMB = fileSize / (1024 * 1024);
        setFileSize(fileSizeInMB);
        const reader = new FileReader();
        reader.onloadend = async () => {
          const chatBotImage = reader.result;
          // Un wanted axios code removed and replaced with redux thunk for file upload
          // axios.post("https://wapi.rizee.in/file-upload", {
          //   "category": "chatbot",
          //   "file": chatBotImage,
          //   "client_id": localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).client_id : ""
          // })
          //   .then(response => {
          //     // console.log("response1111", response.data);
          //   setUrl(response.data.destinationPath);

          //   setState((prevState) => ({
          //     ...prevState,
          //     [name]: response.data.destinationPath,
          //   }));

          //   setNodes((nodes) =>
          //     nodes.map((node) => {
          //       if (node.id === id) {
          //         return {
          //           ...node,
          //           data: {
          //             ...node.data,
          //             state: {
          //               ...node.data.state,
          //               [name]: response.data.destinationPath,
          //             },
          //           },
          //         };
          //       }
          //       return node;
          //     })
          //   );
          // })
          //   .catch(error => {
          //     console.error("Error", error);
          //   });

          const file = [{ filename: selectedFile.name, img: chatBotImage }];
          try {
            const uploadResult = await dispatch(
              uploadFileThunk({
                credentials: { file, category: "userImages" },
              })
            );

            if (
              uploadResult.meta.requestStatus !== "fulfilled" ||
              !uploadResult.payload?.data?.length
            ) {
              return setSnackbar({
                open: true,
                message: uploadResult.payload?.message || "File upload failed",
                severity: "error",
              });
            }

            const uploadedFileData = uploadResult.payload.data[0];
            const uploadedPath = uploadedFileData.file_url;
            console.log("uploadedPath", uploadResult);
            setUrl(uploadedFileData);

            // Update state with the uploaded file data (full object)
            setState((prevState) => ({
              ...prevState,
              [name]: uploadedFileData,
            }));

            // Update nodes with the uploaded file data (full object)
            setNodes((nodes) =>
              nodes.map((node) => {
                if (node.id === id) {
                  return {
                    ...node,
                    data: {
                      ...node.data,
                      state: {
                        ...node.data?.state,
                        [name]: uploadedFileData,
                      },
                    },
                  };
                }
                return node;
              })
            );

            const isSuccess = uploadResult.meta.requestStatus === "fulfilled";

            setSnackbar({
              open: true,
              message: isSuccess
                ? uploadResult.payload.message
                : uploadResult.payload || "File creation failed",
              severity: isSuccess ? "success" : "error",
            });
          } catch {
            setSnackbar({
              open: true,
              message: "Server error. Please try again.",
              severity: "error",
            });
          }
        };
        reader.readAsDataURL(selectedFile);
      }
    } else if (name === "buttons") {
      setState((prevState) => {
        const newState = { ...prevState };
        if (name === "buttons") {
          newState.buttons = prevState.buttons.map((button, i) =>
            i === index ? { ...button, value: value } : button
          );
        }

        // Update nodes with the new state immediately
        setNodes((nodes) =>
          nodes.map((node) => {
            if (node.id === id) {
              return {
                ...node,
                data: {
                  ...node.data,
                  state: {
                    ...node.data?.state,
                    buttons: newState.buttons,
                  },
                },
              };
            }
            return node;
          })
        );

        return newState;
      });
    } else if (name === "list") {
      setState((prevState) => {
        const newState = { ...prevState };
        if (name === "list") {
          newState.list = prevState.list.map((item, i) =>
            i === index ? { ...item, value: value } : item
          );
        }

        // Update nodes with the new state immediately
        setNodes((nodes) =>
          nodes.map((node) => {
            if (node.id === id) {
              return {
                ...node,
                data: {
                  ...node.data,
                  state: {
                    ...node.data?.state,
                    list: newState.list,
                  },
                },
              };
            }
            return node;
          })
        );

        return newState;
      });
    } else {
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === id) {
            return {
              ...node,
              data: {
                ...node.data,
                state: {
                  ...node.data?.state,
                  [name]: value,
                },
              },
            };
          }
          return node;
        })
      );
    }
  };

  const addButton = () => {
    const newState = { ...state };
    if (newState.buttons && newState.buttons.length > 0) {
      const newButton = {
        id: newState.buttons.length + 1,
        value: "",
      };
      newState.buttons = [...newState.buttons, newButton];
    } else {
      newState.buttons = [
        {
          id: 1,
          value: "",
        },
      ];
    }
    setState(newState);
    setState((prevState) => ({
      ...prevState,
      listButton: "",
      list: [],
    }));
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              state: {
                ...node.data?.state,
                list: [],
                listButton: "",
                buttons: newState.buttons,
              },
            },
          };
        }
        return node;
      })
    );
  };

  const addList = () => {
    const newState = { ...state };
    if (newState.list && newState.list.length > 0) {
      const neList = {
        id: newState.list.length + 1,
        value: "",
      };
      newState.list = [...newState.list, neList];
    } else {
      newState.list = [
        {
          id: 1,
          value: "",
        },
      ];
    }
    setState(newState);

    setState(
      (prevState) => ({
        ...prevState,
        buttons: [], // Update buttons to an empty array
      }),
      () => {
        // Callback function to execute after state has been updated
        console.log("State updated successfully:");
      }
    );
    setUrl("");
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === id) {
          // Update the buttons array in the node's state
          return {
            ...node,
            data: {
              ...node.data,
              state: {
                ...node.data?.state,
                buttons: [],
                list: newState.list, // Update the list array in the node's state
              },
            },
          };
        }
        return node;
      })
    );
    // setUrl("")
    //   setNodes((nodes) =>
    //   nodes.map((node) => {
    //     if (node.id === id) {
    //       return {
    //         ...node,
    //         data: {
    //           ...node.data,
    //           state: {
    //             ...node.data?.state,
    //             buttons: [],
    //           },
    //         },
    //       };
    //     }
    //     return node;
    //   })
    // );
  };
  const deleteList = () => {
    if (state && state.list && state.list.length > 1) {
      const remainingList = state.list.slice(0, -1);

      setState((prevState) => ({
        ...prevState,
        list: remainingList,
      }));
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === id) {
            return {
              ...node,
              data: {
                ...node.data,
                state: {
                  ...node.data?.state,
                  list: remainingList,
                },
              },
            };
          }
          return node;
        })
      );
    }
  };
  const setFileFunction = (type) => {
    if (type === "text") {
      setShowHeader(true);
      setUrl("");
    } else {
      setShowHeader(false);
    }
  };

  const deleteButton = () => {
    if (state && state.buttons && state.buttons.length > 1) {
      const result = state.buttons.slice(0, -1);
      //  console.log(result)
      setState((prevState) => ({
        ...prevState,
        buttons: result,
      }));

      // Update the nodes with the new state
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === id) {
            return {
              ...node,
              data: {
                ...node.data,
                state: {
                  ...node.data?.state,
                  buttons: result, // Update only the buttons property
                },
              },
            };
          }

          return node;
        })
      );
    }
  };

  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="container"
    >
      <div
        className="text-updater-node overflow-auto pb-3"
        onClick={handleNodeFocus}
      >
        <div
          style={{ padding: "5px" }}
          className="d-flex flex-row items-center justify-center"
        >
          <WhatsAppIcon
            style={{
              fontSize: "20px",
              color: "#22D954",
              borderRadius: "5px",
              padding: "2px",
              marginTop: "5px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0.5px rgba(0, 0, 0, 0.5)",
            }}
          />
          <b className="m-1">Trigger Layout</b>
        </div>
        <div
          style={{ marginTop: "5px", width: "100%" }}
          className="d-flex flex-row justify-content-between content-center"
        >
          <Tooltip title="Add List">
            <Button
              disabled={
                state && state.list && state.list.length >= 8 ? true : false
              }
              onClick={addList}
              className="mr-1 d-flex flex-row"
              style={{ cursor: "pointer" }}
            >
              <span style={{ color: "skyblue", cursor: "pointer" }}>
                <PlaylistAddIcon />
              </span>
            </Button>
          </Tooltip>
          <Tooltip title="Add Button">
            <Button
              disabled={
                state && state.buttons && state.buttons.length >= 3
                  ? true
                  : false
              }
              onClick={addButton}
              className="mr-1 d-flex flex-row"
              style={{ cursor: "pointer" }}
            >
              <span style={{ color: "blue", cursor: "pointer" }}>
                <AddCircleOutlineIcon />
              </span>
            </Button>
          </Tooltip>
        </div>
        {showHeader && (
          <div className="sub_header d-flex flex-column">
            <b>Header</b>
            <div
              style={{
                border: "1px solid #e7e7e7",
                position: "relative",
                borderRadius: "5px",
                fontSize: "9px",
                padding: "3px",
                display: "flex",
              }}
            >
              <input
                type="text"
                name="header"
                value={state && state.header ? state.header : ""}
                style={{
                  border: "none",
                  padding: "5px",
                  width: "100%",
                  outline: "none",
                }}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <span style={{ color: "red" }}>
              {state.header && state.header.length > 20
                ? "Header length should be lessthan 20 char"
                : ""}
            </span>
          </div>
        )}

        <div className="">
          <div
            style={{
              paddingBottom: "5px",
            }}
          >
            {url &&
            url?.file_extension_type &&
            url.file_extension_type.includes("video") ? (
              <div className="flex flex-column">
                <video controls style={{ maxWidth: "100%", maxHeight: "100%" }}>
                  <source src={url.file_url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {fileSize && fileSize > 14 && (
                  <p className="text-red">Video Max size 14MB!</p>
                )}
              </div>
            ) : url &&
              url?.file_extension_type &&
              url.file_extension_type.includes("pdf") ? (
              // You can use react-pdf or another library to render PDFs
              <div className="flex flex-column">
                <b>PDF Selected</b>
                {fileSize && fileSize > 15 && (
                  <p className="text-red">Doc Max size 15MB!</p>
                )}
              </div>
            ) : url ? (
              <div className="flex flex-column">
                <img
                  src={url?.file_url ?? url}
                  alt="Uploaded Image"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
                {fileSize && fileSize > 4 && (
                  <p className="text-gray">Img Max size 4MB!</p>
                )}
              </div>
            ) : null}
          </div>
        </div>

        <div className="sub_header">
          <div
            style={{
              marginBottom: "5px",
              paddingBottom: "5px",
              borderBottom: "1px solid #e7e7e7",
              width: "100%",
            }}
            className="d-flex flex-row justify-content-between"
          >
            <span>
              <b>Body</b>
            </span>
            <span>
              <Button
                variant="secondary"
                color="blue"
                disabled={
                  state && state.list && state.list.length > 0 ? true : false
                }
                onClick={() => setShowHeaderOptions(true)}
              >
                Add Header
              </Button>
              {showHeaderOptions && (
                <div
                  style={{
                    // position: "absolute",
                    top: "100%",
                    left: "0",
                    marginTop: "5px",
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.5)",
                    zIndex: 999,
                  }}
                  onMouseLeave={() => setShowHeaderOptions(false)}
                >
                  <List>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          setFileFunction("text");
                        }}
                      >
                        Text
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          setFileFunction("image");
                        }}
                      >
                        Image
                        <input
                          id="upload-input"
                          type="file"
                          accept="image/png,image/jpg,image/jpeg,image/PNG,image/JPG,image/JPEG,.png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                          name="url"
                          onChange={handleChange}
                          style={{
                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",

                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => setFileFunction("dodument")}
                      >
                        Document
                        <input
                          id="upload-input"
                          type="file"
                          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.pdf,.doc,.docx,.xls,.xlsx,.PDF,.DOC,.DOCX,.XLS,.XLSX"
                          name="url"
                          onChange={handleChange}
                          style={{
                            // position: "absolute",
                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",
                            // height: "100%",
                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => setFileFunction("video")}>
                        Video
                        <input
                          id="upload-input"
                          type="file"
                          accept="audio/mpeg,video/mp4,audio/mp3,audio/MP3,video/MP4,audio/MPEG,.mp3,.mp4,.MP3,.MP4"
                          name="url"
                          onChange={handleChange}
                          style={{
                            // position: "absolute",
                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",
                            // height: "100%",
                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </div>
              )}
            </span>{" "}
            {/* <span><a href="#"onClick={()=>setShowFooter(true)}>Add Footer</a></span> */}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <textarea
              type="text"
              name="message"
              value={state ? state.message : ""}
              onChange={(e) => handleChange(e)}
              style={{
                border: "1px solid #e7e7e7",
                borderRadius: "5px",
                padding: "5px",
                outline: "none",
                height: 60,

                resize: "none",
              }}
            />
            <span style={{ color: "red" }}>
              {state && state.message && state.message.length > 1024
                ? "Body length should be lessthan 1024 char"
                : ""}
            </span>
            {state &&
            state.buttons !== undefined &&
            state.buttons.length > 0 ? (
              <>
                <span>
                  <b>Buttons</b>
                </span>
                {state.buttons.map((item, index) => (
                  <div key={index}>
                    <div>Button {index + 1}</div>
                    <div
                      style={{
                        border: "1px solid #e7e7e7",
                        position: "relative",
                        borderRadius: "5px",
                        fontSize: "9px",
                        padding: "3px",
                        display: "flex",
                      }}
                    >
                      <input
                        type="text"
                        name="buttons"
                        value={item ? item.value : ""}
                        style={{
                          border: "none",
                          padding: "5px",
                          width: "100%",
                          outline: "none",
                        }}
                        onChange={(e) => handleChange(e, index)}
                      />
                      <Handle
                        type="source"
                        position={Position.Right}
                        id={`bc-${index}-ds`}
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        isConnectable={isConnectable}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {item.value.length > 20
                        ? "Button length should be lessthan 20 char"
                        : ""}
                    </span>
                  </div>
                ))}
                <div className="d-flex flex-row justify-content-between p-1">
                  <Button
                    style={{
                      color: state.buttons.length < 2 ? "none" : "red",
                    }}
                    type="button"
                    onClick={deleteButton}
                    disabled={state.buttons.length < 2}
                  >
                    Delete
                  </Button>
                  <Button
                    type="button"
                    onClick={addButton}
                    disabled={state.buttons.length >= 3}
                  >
                    Add
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}

            {state && state.list && state.list.length > 0 ? (
              <>
                <span>
                  <b>List</b>
                  <div className="sub_header d-flex flex-column">
                    <b>List Button</b>
                    <div
                      style={{
                        border: "1px solid #e7e7e7",
                        position: "relative",
                        borderRadius: "5px",
                        fontSize: "9px",
                        padding: "3px",
                        display: "flex",
                      }}
                    >
                      <input
                        type="text"
                        name="listButton"
                        value={
                          state && state.listButton ? state.listButton : ""
                        }
                        style={{
                          border: "none",
                          padding: "5px",
                          width: "100%",
                          outline: "none",
                        }}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {state && state.listButton && state.listButton.length > 20
                        ? "List Button length should be lessthan 20 char"
                        : ""}
                    </span>
                  </div>
                </span>
                {state.list.map((item, index) => (
                  <div key={index}>
                    <div>Item {index + 1}</div>
                    <div
                      style={{
                        border: "1px solid #e7e7e7",
                        position: "relative",
                        borderRadius: "5px",
                        fontSize: "9px",
                        padding: "3px",
                        display: "flex",
                      }}
                    >
                      <input
                        type="text"
                        name="list"
                        value={item ? item.value : ""}
                        style={{
                          border: "none",
                          padding: "5px",
                          width: "100%",
                          outline: "none",
                        }}
                        onChange={(e) => handleChange(e, index)}
                      />
                      <Handle
                        type="source"
                        position={Position.Right}
                        id={`ab-${index}-sd`}
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        isConnectable={isConnectable}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {item.value.length > 24
                        ? "List length should be lessthan 24 char"
                        : ""}
                    </span>
                  </div>
                ))}
                <div className="d-flex flex-row justify-content-between p-1">
                  <Button
                    style={{
                      color: state.list.length < 2 ? "none" : "red",
                    }}
                    type="button"
                    onClick={deleteList}
                    disabled={state.list.length < 2}
                  >
                    Delete
                  </Button>
                  <Button
                    type="button"
                    onClick={addList}
                    disabled={state.list.length === 8}
                  >
                    Add
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        {showFooter && (
          <div className="sub_header d-flex flex-column">
            <b>Footer</b>
            <div
              style={{
                border: "1px solid #e7e7e7",
                position: "relative",
                borderRadius: "5px",
                fontSize: "9px",
                padding: "3px",
                display: "flex",
              }}
            >
              <input
                type="text"
                name="footer"
                value={state && state.footer ? state.footer : ""}
                style={{
                  border: "none",
                  padding: "5px",
                  width: "100%",
                  outline: "none",
                }}
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
        )}
        <Handle
          type="target"
          position={Position.Top}
          id="d"
          style={{
            background: "#ADADAD",
            width: "8px",
            height: "8px",
            borderRadius: "60%",
            left: 17,
          }}
          isConnectable={isConnectable}
        />
        {/* <div className="footer">
          
          <Handle
            type="source"
            position={Position.Right}
            id="ac"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: "8px",
            }}
            isConnectable={isConnectable}
          />
        </div> */}
      </div>

      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </div>
  );
}

export default CustomNode;
